import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";
import { FC } from "react";

interface BatteryOriginWarningParams {
  onAccept?: () => void;
}

export const BatteryOriginWarning: FC<BatteryOriginWarningParams> = ({
   onAccept 
  }) => {
  const { t } = useTranslation();
  const Settings = useSettingsContext();

  const handleContinue = () => {
    onAccept?.();
  };

  return (
    <Dialog open={true}>
      <DialogTitle>
        {t("common:text.battery_origin_warning_title")}
      </DialogTitle>
      <DialogContent style={{ textAlign: "justify" }}>
        <Typography paragraph>
          {t("common:text.battery_origin_warning_content", {
            comerEmail: Settings.organization?.email,
          })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleContinue}
          color="primary"
          autoFocus
          variant="contained"
        >
          {t("common:text.battery_origin_warning_continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BatteryOriginWarning;
